export default "__VITE_ASSET__Ba15ijsB__"